import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { httpOptions } from 'src/app/global/global_variables';
import { environment } from 'src/environments/environment';
import { ChassisTripsModel } from 'src/app/models/ChassisResponse';
import { ChassisTimeTableModel } from 'src/app/models/ChassisTimeTable';
import { ChassisUpdateModel } from 'src/app/models/ChassisUpdateModel';
import { DocksModel } from 'src/app/models/DocksModel';

@Injectable({
  providedIn: 'root'
})
export class ChassisService {

  apiLink = environment.apiLink;
  httpOption = httpOptions

  constructor(private http: HttpClient) { }

  // TIME-TABLE METHODS

  getAllTrips(): Observable<ChassisTimeTableModel[]> {
    return this.http.get<ChassisTimeTableModel[]>(`${this.apiLink}/Chassis/TimeTable`)
  }

  getTripById(id: number): Observable<ChassisTimeTableModel> {
    return this.http.get<ChassisTimeTableModel>(`${this.apiLink}/Chassis/TimeTable/${id}`)
  }

  createTrip(request: ChassisTimeTableModel) {
    return this.http.post(`${this.apiLink}/Chassis/TimeTable`, request)
  }

  updateTrip(request: ChassisTimeTableModel, id: number) {
    return this.http.put(`${this.apiLink}/Chassis/TimeTable/${id}`, request)
  }

  deleteTrip(id: number): Observable<any> {
    return this.http.delete(`${environment.apiLink}/Chassis/TimeTable/${id}`);
  }

  // AUXILIARY TAKT METHODS

  getActiveTrips(): Observable<ChassisTripsModel[]> {
    return this.http.get<ChassisTripsModel[]>(`${this.apiLink}/Chassis/Trips`)
  }

  getActiveTripsView(): Observable<ChassisTripsModel[]> {
    return this.http.get<ChassisTripsModel[]>(`${this.apiLink}/View/Chassis/Trips`)
  }

  updateChassisTripsTable(request: ChassisUpdateModel) {
    return this.http.put(`${this.apiLink}/Chassis/Trips`, request)
  }

  // VIEW METHODS

  getChassisDocksDataView(): Observable<DocksModel[]> {
    return this.http.get<DocksModel[]>(`${this.apiLink}/View/Chassis/Docks`, httpOptions)
  }

  getTripByIdView(id: number): Observable<ChassisTimeTableModel> {
    return this.http.get<ChassisTimeTableModel>(`${this.apiLink}/View/Chassis/TimeTable/${id}`)
  }
}
